import React from "react";
import ReactDOM from "react-dom/client";

import { OutreachCRM } from "../app/outreach-crm";
import "../app/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <OutreachCRM />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // The CRM remains fully usable online if installation support is unavailable.
    });
  });
}

